import {ReactNode} from 'react'
import './Typography.scss'

export const Description = ({children, className}: { className?: string, children?: ReactNode }) => {
    return <p className={'description ' + (className ? className : '')}>{children}</p>
}